import React from "react";

export const BeamsBackground = () => {
  return (
    <div className="absolute inset-0 -z-10 overflow-hidden">
      <svg
        aria-hidden="true"
        className="absolute left-[max(-7rem,calc(50%-52rem))] top-1/2 transform -translate-y-1/2 -z-10 h-[64rem] w-[128rem] rotate-[30deg] stroke-purple-600/10 opacity-30"
      >
        <defs>
          <pattern
            id="beams-pattern"
            width="72"
            height="56"
            patternUnits="userSpaceOnUse"
            x="50%"
            y="50%"
          >
            <path
              d="M.5 56V.5H72"
              fill="none"
              strokeDasharray="8 4"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" strokeWidth="0" fill="url(#beams-pattern)" />
      </svg>
      <svg
        aria-hidden="true"
        className="absolute left-[max(45rem,calc(50%+28rem))] top-1/2 transform -translate-y-1/2 -z-10 h-[64rem] w-[128rem] -rotate-[30deg] stroke-purple-600/10 opacity-30"
      >
        <defs>
          <pattern
            id="beams-pattern-2"
            width="72"
            height="56"
            patternUnits="userSpaceOnUse"
            x="50%"
            y="50%"
          >
            <path
              d="M.5 56V.5H72"
              fill="none"
              strokeDasharray="8 4"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" strokeWidth="0" fill="url(#beams-pattern-2)" />
      </svg>
    </div>
  );
}; 